import { Row, Col } from 'react-bootstrap';
import {useState, useEffect, useRef} from 'react';
import Card  from '../../ui/Card';
import SearchResultContainer from './searchResultContainer';
import { useForm } from 'react-hook-form';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import swal from 'sweetalert';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService"

const ADTRExpenditureUpdate = (props) => {
    const [showSearchResult, setShowSearchResult] = useState(false);
    const { handleSubmit} = useForm();
    const [isLoading, setIsLoading] = useState(true);
    const [cdiacNumbers, setCdiacNumbers] = useState([]);
    const [finalSaleId, setFinalSaleId] = useState("");
    const [adtrs, setAdtrs] = useState([]);
    const [adtrId, setAdtrId] = useState("");
    const [adtrProceeds, setAdtrProceeds] = useState([]);
    const [adtrProceedId, setAdtrProceedId] = useState("");
    const adtrProceedRef = useRef(null);

    
    const handleCdiacChange = (e, key) => {
      const checkValue = e.length > 0 ? e[0][key] : '';
      setAdtrId('');
      setAdtrProceeds([]);
      setAdtrProceedId('');
      adtrProceedRef?.current?.clear();
      setFinalSaleId(checkValue); 
      if(checkValue){
        getAdtrsByFinalSaleId(checkValue);
      }
    }

    const handleAdtrChange = (e, key) => {
      const checkValue = e.length > 0 ? e[0][key] : '';
      setAdtrId(checkValue);
      if(checkValue){
        getAdtrProceedsByAdtrId(checkValue);
      }
    }

    const handleAdtrProceedChange = (e, key) => {
      if(e.length){
      setAdtrProceedId(e.length > 0 ? e[0][key] : '');
      }
    }

    const onSubmit = (data) => {
       if(finalSaleId === '' || adtrId === '' || adtrProceedId === '') {
          var name = 'Please select cdiac number, adtr, and procced!';
          var content = document.createElement('div');
          content.innerHTML = '<strong>'+ name +'</strong>';
          swal(content);
          return;
        }
        setShowSearchResult(true);
    }

    useEffect(() => {
      getCdiacNumbers()
    }, []);

    const getCdiacNumbers = () => {  
      var obj = {
        msgId: null,
        sysId: null,
        opr: "getCdiacFinalSale",
        hdrStruct: null,
        queryParam: null,
        reqData: {
          "updateType": "FinalSale"
         },
      };
  
      BaseService.processRequest(obj)
        .then((res) => res)
        .then((result) => {
          Object.keys(result.data.responses).forEach((key) => {
              setCdiacNumbers(result.data.responses[key]);
          });
          setIsLoading(false);
        });
    }

  const getAdtrsByFinalSaleId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrs(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }


  const getAdtrProceedsByAdtrId = (selectedAdtrId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrProceedByAdtr",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "adtrId": selectedAdtrId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrProceeds(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

    return (
        <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
              <div className="panel-heading">
                <div className="container">
                    <div id="packet_id" className="panel-title">
                        <h1 className="menu-title">ADTR Proceed Expenditure Update</h1>
                        
                    </div>
                </div>
              </div>
              <div className="panel-body">
                <div className="container">
                  <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                          <label>CDIAC Number: </label>
                          <Typeahead
                            placeholder="Choose CDIAC Number"
                            id="finalsale"
                            labelKey="cdiacNumber"
                            onChange={e=>handleCdiacChange(e, "finalSaleId")}
                            inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                            options={cdiacNumbers}
                            sort
                          />
                      </div>
                    
                    </Col>
                  </Row>
                  <Row>
                    {finalSaleId && <Col md={6}>
                      <div className="control">
                          <label>ADTR: </label>
                          <Typeahead
                            placeholder="Choose ADTR"
                            id="adtrId"
                            labelKey={(adtrItem) => CommonService.dateFormatter(adtrItem.fiscalYrEndDate)}
                            onChange={e=>handleAdtrChange(e, "adtrId")}
                            inputProps={{ 'data-validations': 'required', name: 'fiscalYrEndDate' }}
                            options={adtrs}
                          />
                      </div>
                    </Col>}
                    {adtrId && <Col md={6}>
                      <div className="control">
                          <label>ADTR Fund Category: </label>
                          <Typeahead
                            placeholder="Choose Fund Category"
                            id="adtrProceedId"
                            labelKey= "fundCategoryText"
                            onChange={e=>handleAdtrProceedChange(e, "adtrProceedId")}
                            inputProps={{ 'data-validations': 'required', name: 'fundCategoryText' }}
                            ref={adtrProceedRef}
                            options={adtrProceeds}
                          />
                      </div>
                    </Col>}
                  </Row>
                  
                  <div style={{overflow: 'auto'}}>
                    <div className="fleft">
                      <a href="/admin" className="dk-blue-color link-button">Back to Admin</a>
                    </div>
                    <button style={{float: 'right', marginBottom: '0'}} className="custom-button" type="Submit" onClick={handleSubmit(onSubmit)}>Search</button>
                  </div>
                  </div>
                </div>
              </div>
          </div>
          {showSearchResult && <SearchResultContainer adtrProceedId={adtrProceedId} />}         
           
        </Card>
        </form>
    )
}

export default ADTRExpenditureUpdate
